<button
  [attr.form]="attachedForm"
  type="submit"
  class="o-button {{
    className
  }} o-button--medium c-loader-button c-loader-button--iconless {{
    buttonStatus
  }} {{ className }}"
  [disabled]="disabled || isLoading"
  [ngClass]="{ 'o-button--responsive': responsive }"
>
  <div class="c-loader__wrapper">
    <div class="c-loader c-loader--small">
      <i class="fa fa-spinner" aria-hidden="true"></i>
    </div>
  </div>
  <!-- TODO HOS-7317 When dyamic translations available make sure the labels gets translated -->
  <!--<span i18n="Button|Label for save BUTTON">BUTTON_SAVE</span>-->
  <div class="c-loader__content">
    <i class="fa fa-check" aria-hidden="true"></i>
    <span>{{ buttonText | lsTranslate }}</span>
  </div>
  <div class="c-loader__output">
    <i class="fa fa-check" aria-hidden="true"></i>
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
  </div>
</button>

<div id="Save" i18n="@@Save" ls-dynamic-translation>Save</div>
